import { QueryHookOptions, useQuery } from '@apollo/client';

import { gql } from '@/generated';
import { useFilterConditions } from '@/contexts';
import { ImpactKpisPageQuery, ImpactKpisPageQueryVariables } from '@/generated/graphql';

const QUERY = gql(/* GraphQL */ `
  query ImpactKpisPage($filter: [FilterCond]) {
    forestryIndicators(filter: $filter) {
      ...KPIImpact_LandManagedFragment
      ...KPIImpact_LandProtectedFragment
      ...KPIImpact_LandRestoredFragment
      ...KPIImpact_EmissionsRemovedFragment
      ...KPIImpact_EmissionRemovedFragment
      ...KPIImpact_ForestBeneficiariesFragment
      ...KPIImpact_DecentJobsFragment
      ...KPIImpact_InvesteeRevenueGrowthFragment
    }
  }
`);

export function useImpactKpisData(
  options: QueryHookOptions<ImpactKpisPageQuery, ImpactKpisPageQueryVariables> = {}
) {
  const { viewer, benchmark } = useFilterConditions();
  const benchmarkQuery = useQuery(QUERY, { variables: { filter: benchmark }, ...options });
  const viewerQuery = useQuery(QUERY, { variables: { filter: viewer }, skip: !viewer });

  return {
    loading: benchmarkQuery.loading || viewerQuery.loading,
    benchmarkQuery,
    viewerQuery,
    benchmarkData: benchmarkQuery.data?.forestryIndicators,
    viewerData: viewerQuery.data?.forestryIndicators,
  };
}
